import { TApplicationState } from 'shared/types/redux';

export const fromAgentsPropsCountUrlSelector = (state: TApplicationState) => {
  return state.newbuilding.stats.fromAgentsPropsCountUrl;
};
